<ngb-alert [type]="type" *ngIf="isVisible" [dismissible]="false" class="alert-container">
  <div class="alert-body">
    <span *ngIf="showIcon">
      <i id="message-icon" class="feather" [ngClass]="icon"> </i>
    </span>
    <span class="text-break">{{message}} </span>
  </div>
  <div *ngIf="dismissible" id="dismiss-icon" (click)="hide()">
    <span class="feather icon-x"></span>
  </div>
</ngb-alert>
